type ToolArgs = Record<string, unknown>;

const TEMPLATE_SECTIONS: Record<string, string> = {
  survey: "surveys",
  performance_review: "performance-reviews",
};

const numberOf = (value: unknown) => (typeof value === "number" ? value : undefined);

const templateLink = (output: ToolArgs, step: string) => {
  const id = numberOf(output.id);
  const section = typeof output.type === "string" ? TEMPLATE_SECTIONS[output.type] : undefined;
  return id && section ? `/templates/${section}/${id}/setup/${step}` : undefined;
};

/** Страница объекта, который создал или изменил инструмент шлюза; undefined — ссылки нет. */
export function buildAiAssistantObjectLink(
  toolName: string,
  input: ToolArgs,
  output: unknown
): string | undefined {
  const result = (output && typeof output === "object" ? output : {}) as ToolArgs;
  const id = numberOf(result.id);

  switch (toolName) {
    case "create_form_template":
    case "update_form_template":
    case "duplicate_form_template":
    case "move_form_template":
      return templateLink(result, "details");
    case "update_form_template_form":
      return templateLink(result, "questions");
    case "create_form_template_folder": {
      const section = typeof input.type === "string" ? TEMPLATE_SECTIONS[input.type] : undefined;
      return id && section ? `/templates/${section}/folders/${id}` : undefined;
    }
    case "create_survey_draft":
    case "update_survey":
    case "duplicate_survey":
      return id ? `/surveys/${id}/setup/details` : undefined;
    // Возвращает форму, а не опрос: id опроса берём из аргументов
    case "update_survey_form": {
      const surveyId = numberOf(input.survey_id);
      return surveyId ? `/surveys/${surveyId}/setup/questions` : undefined;
    }
    case "create_performance_review_draft":
    case "update_performance_review":
    case "duplicate_performance_review":
      return id ? `/performance-reviews/${id}/setup/details` : undefined;
    case "update_performance_review_form": {
      const reviewId = numberOf(input.performance_review_id);
      return reviewId ? `/performance-reviews/${reviewId}/setup/forms` : undefined;
    }
    case "create_goal":
    case "update_goal":
    case "create_key_result":
    case "update_key_result":
    case "checkin_goal":
      return id ? `/goals/${id}` : undefined;
    default:
      return undefined;
  }
}
